
// BinaryReader
// Refactored by Vjeux <vjeuxx@gmail.com>
// http://blog.vjeux.com/2010/javascript/javascript-binary-reader.html

// Original
//+ Jonas Raoni Soares Silva
//@ http://jsfromhell.com/classes/binary-parser [rev. #1]


class BinaryReader {
  constructor(data) {
    this._buffer = data;
    this._pos = 0;
    this.base64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
  }

	/* Public */
	readAFloat(){
		var i = this.readAUInt32();
		return this._decodeFloat(i);
	}

	readInt8(){ return this._decodeInt(8, true); }
	readUInt8(){ return this._decodeInt(8, false); }
	readInt16(){ return this._decodeInt(16, true); }
	readUInt16(){ return this._decodeInt(16, false); }
	readInt32(){ return this._decodeInt(32, true); }
	readUInt32(){ return this._decodeInt(32, false); }
	readVarInt(){ return this._decodeVarInt();}

	readFloat(){
		var i = this._decodeInt(32, false);
		return this._decodeFloat(i);
	}

	seek (pos) {
		this._pos = pos;
		this._checkSize(0);
	}

	skip(count) {
		this._checkSize(count);
		this._pos += count;
	}

	getPosition () {
		return this._pos;
	}

	getSize () {
		return this._buffer.length;
	}

	readBits(count) {
		this._checkSize(count);
		return this._readBits(count);
	}

	readUTF8String(count){
		var byte_array = this.readArrayOfBits(8, count);
		var codePoints = [];
		for(var i = 0; i < byte_array.length; i++){
			var _byte = byte_array[i];
			if((_byte & 128) === 0){
				codePoints.push(_byte);
			}else if((_byte & 224) === 192){
				let codePoint = (_byte & 31) << 6;
				i++;
				_byte = byte_array[i];
				codePoint += _byte & 63;
				codePoints.push(codePoint);
			}else if((_byte & 240) === 224){
				let codePoint = (_byte & 15) << 12;
				i++;
				codePoint += (byte_array[i] & 63) << 6;
				i++;
				codePoint += (byte_array[i] & 63);
				codePoints.push(codePoint);
			}else if((_byte & 248) === 240){
				let codePoint = (_byte & 7) << 18;
				i++;
				codePoint += (byte_array[i] & 63) << 12;
				i++;
				codePoint += (byte_array[i] & 63) << 6;
				i++;
				codePoint += (byte_array[i] & 63);
				codePoints.push(codePoint);
			}else{
				console.log("?");
			}

		}
		return String.fromCodePoint.apply(null, codePoints);
	}

	readString(count) {
		var a;
		this._checkSize(count * 8);
		if (this._pos % 8 === 0) {
			a = Array.prototype.slice.call(this._buffer, this._pos >> 3, (this._pos >> 3) + count);
			this._pos += 8 * count;
		} else
			a = this.readArrayOfBits(8, count);
		return String.fromCharCode.apply(null, a);
	}

	readBase64String(count) {
		this._checkSize(count * 8);
		var str = '';
		while (count > 0) {
			var e0, e1, e2, e3;
			var c0 = this.readUInt8() & 0xFF;
			count--;

			if (count === 0) {
				e0 = c0 >> 2;
				e1 = ((c0 & 3) << 4);
				e2 = e3 = 64;
			} else {
				var c1 = this.readUInt8() & 0xFF;
				count--;

				if (count === 0) {
					e0 = c0 >> 2;
					e1 = ((c0 & 3) << 4) | (c1 >> 4);
					e2 = ((c1 & 15) << 2);
					e3 = 64;
				} else {
					var c2 = this.readUInt8() & 0xFF;
					count--;

					e0 = c0 >> 2;
					e1 = ((c0 & 3) << 4) | (c1 >> 4);
					e2 = ((c1 & 15) << 2) | (c2 >> 6);
					e3 = c2 & 63;
				}
			}
			str = str +
				this.base64.charAt(e0) + this.base64.charAt(e1) +
				this.base64.charAt(e2) + this.base64.charAt(e3);
		}
		return str;
	}

	alignToByte() {
		let count = (8 - (this._pos % 8)) % 8;
		//log("align to byte: " + (this._pos % 8) + "," + count);
		this._readBits(count);
	}

	/* Private */
	_decodeInt(bits, signed){
		var x = this._readBits(bits);
		if (signed) {
			var max = Math.pow(2, bits);
			if (x >= max / 2) {
				x = x-max;
			}
		}
		return x;
	}

	_decodeVarInt(){
		var ret = 0;
		var i = 0;
		while(true){
			var x = this._readBits(8);
			ret |= (x & 127) << 7*i;
			if(!(x & 128)){
				break;
			}
			i++;
		}
		ret = (ret >> 1) ^ (-(ret & 1));
		return ret;
	}

	_decodeFloat (i){
		var bias = 127;
		var signal = (i >> 31) & 1;
		var exponent = (i >> 23) & 0xff;
		var significand = (i & 0x7fffff) / 8388608.;

		return exponent === 255 ? significand ? NaN : signal ? -Infinity : +Infinity
			: (1 + signal * -2) * (exponent || significand ? !exponent ? Math.pow(2, -bias + 1) * significand
			: Math.pow(2, exponent - bias) * (1 + significand) : 0);

	}

	_checkSize (neededBits) {
		if (this._pos + neededBits > this._buffer.length * 8) {
			throw new Error("Index out of bound");
		}
	}

	_checkAligned () {
		if (this._pos % 8 !== 0) {
			throw new Error("Unaligned read");
		}
	}
};

export class BinaryReaderArrayBuffer extends BinaryReader {

	/* Public */
	readAUInt8 () {
		var i = this._pos >> 3;
		this._pos += 8;
		return this._buffer[i];
	}
	readAUInt16 () {
		var i = this._pos >> 3;
		this._pos += 16;
		return (this._buffer[i] << 8) | this._buffer[i + 1];
	}
	readAUInt32 () {
		var i = this._pos >> 3;
		this._pos += 32;
		return (this._buffer[i] << 24) | (this._buffer[i + 1] << 16) |
		       (this._buffer[i + 2] << 8) | this._buffer[i + 3];
	}

	_readBits (length) {
		var avail = (8 - (this._pos % 8));
		var c = this._buffer[this._pos >> 3];

		if (length < avail) {
			this._pos += length;
			let sum = (c >> (avail - length)) & ((1 << length) - 1);
			return sum;
		}
		var sum = c & ((1 << avail) - 1);
		length -= avail;
		this._pos += avail;
		while (length > 8) {
			sum <<= 8;
			c = this._buffer[this._pos >> 3];
			sum += c & 0xff;
			avail = 8;
			length -= 8;
			this._pos += 8;
		}

		if (length) {
			sum <<= length;
			c = this._buffer[this._pos >> 3];
			c = (c >> (8 - length)) & ((1 << length) - 1);
			sum += c;
			this._pos += length;
		}

		return sum;
	}

	readArrayOfShorts (count) {
		this._checkSize(16 * count);
		var array = new Array(count);
		var j = this._pos >> 3;
		for (var i = 0; i < count; i++)
			array[i] = (this._buffer[j++] << 8) | this._buffer[j++];
		this._pos += 16 * count;
		return array;
	}

	readArrayOfBits (bits, count) {
		this._checkSize(bits * count);
		var array = new Array(count);
		var _pos = this._pos;
		var avail = (8 - (_pos % 8));
		for (var i = 0; i < count; i++) {

			var c = this._buffer[_pos >> 3];
			var sum;

			if (bits < avail) {
				_pos += bits;
				sum = (c >> (avail - bits)) & ((1 << bits) - 1);
				avail -= bits;
				array[i] = sum;
				continue;
			}

			var length = bits;
			sum = c & ((1 << avail) - 1);
			length -= avail;
			_pos += avail;
			while (length > 8) {
				sum <<= 8;
				c = this._buffer[_pos >> 3];
				sum += c & 0xff;
				avail = 8;
				length -= 8;
				_pos += 8;
			}
			if (length) {
				sum <<= length;
				c = this._buffer[_pos >> 3];
				c = (c >> (8 - length)) & ((1 << length) - 1);
				sum += c;
				_pos += length;
			}

			avail = (8 - (_pos % 8));

			array[i] = sum;
		}

		this._pos = _pos;
		return array;
	}
};

export class BinaryReaderString extends BinaryReader {
	/* Public */
	readAUInt8 () {
		var i = this._pos >> 3;
		this._pos += 8;
		return (this._buffer.charCodeAt(i) & 0xff);
	}
	readAUInt16 () {
		var i = this._pos >> 3;
		this._pos += 16;
		return ((this._buffer.charCodeAt(i) & 0xff) << 8) | (this._buffer.charCodeAt(i + 1) & 0xff);
	}
	readAUInt32 () {
		var i = this._pos >> 3;
		this._pos += 32;
		return ((this._buffer.charCodeAt(i) & 0xff) << 24) | ((this._buffer.charCodeAt(i + 1) & 0xff) << 16) |
		((this._buffer.charCodeAt(i + 2) & 0xff) << 8) | (this._buffer.charCodeAt(i + 3) & 0xff);
	}

	_readBits (length) {
		var avail = (8 - (this._pos % 8));
		var c = this._buffer.charCodeAt(this._pos >> 3) & 0xff;

		if (length < avail) {
			this._pos += length;
			let sum = (c >> (avail - length)) & ((1 << length) - 1);
			return sum;
		}
		var sum = c & ((1 << avail) - 1);
		length -= avail;
		this._pos += avail;
		while (length > 8) {
			sum <<= 8;
			c = this._buffer.charCodeAt(this._pos >> 3) & 0xff;
			sum += c & 0xff;
			avail = 8;
			length -= 8;
			this._pos += 8;
		}

		if (length) {
			sum <<= length;
			c = this._buffer.charCodeAt(this._pos >> 3) & 0xff;
			c = (c >> (8 - length)) & ((1 << length) - 1);
			sum += c;
			this._pos += length;
		}

		return sum;
	}

	readArrayOfShorts (count) {
		this._checkSize(16 * count);
		var array = new Array(count);
		var j = this._pos >> 3;
		for (var i = 0; i < count; i++)
			array[i] = ((this._buffer.charCodeAt(j++) & 0xff) << 8) | (this._buffer.charCodeAt(j++) & 0xff);
		this._pos += 16 * count;
		return array;
	}

	readArrayOfBits (bits, count) {
		this._checkSize(bits * count);
		var array = new Array(count);
		var _pos = this._pos;
		var avail = (8 - (_pos % 8));
		for (var i = 0; i < count; i++) {

			var c = this._buffer.charCodeAt(_pos >> 3) & 0xff;
			var sum;

			if (bits < avail) {
				_pos += bits;
				sum = (c >> (avail - bits)) & ((1 << bits) - 1);
				avail -= bits;
				array[i] = sum;
				continue;
			}

			var length = bits;
			sum = c & ((1 << avail) - 1);
			length -= avail;
			_pos += avail;
			while (length > 8) {
				sum <<= 8;
				c = this._buffer.charCodeAt(_pos >> 3) & 0xff;
				sum += c & 0xff;
				avail = 8;
				length -= 8;
				_pos += 8;
			}
			if (length) {
				sum <<= length;
				c = this._buffer.charCodeAt(_pos >> 3) & 0xff;
				c = (c >> (8 - length)) & ((1 << length) - 1);
				sum += c;
				_pos += length;
			}

			avail = (8 - (_pos % 8));

			array[i] = sum;
		}

		this._pos = _pos;
		return array;
	}
};
